<template>
  <section class="impact reveal-section" id="impacto" ref="sectionRef">
    <div class="section-header">
      <span class="section-label" style="color:var(--vh-dorado)">Nuestro Alcance</span>
      <h2 class="section-title">Impacto Real</h2>
      <p class="section-subtitle">Números que representan vidas transformadas por el poder de Dios</p>
    </div>
    <div class="impact-grid">
      <div v-for="(item, i) in stats" :key="i" class="impact-item">
        <span class="impact-number" :data-target="item.target">0</span>
        <span class="impact-label">{{ item.label }}</span>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useScrollReveal } from '@/composables/useAnimations'

const sectionRef = ref < HTMLElement | null > (null)
const { registerReveal } = useScrollReveal()
onMounted(() => registerReveal(sectionRef.value))

const stats = ref([
  { target: 1200, label: 'Niños Capacitados' },
  { target: 350, label: 'Jóvenes Líderes' },
  { target: 45, label: 'Iglesias Aliadas' },
  { target: 8, label: 'Departamentos' }
])
</script>

<style scoped>
.impact {
  background: linear-gradient(135deg, var(--vh-azul-profundo) 0%, var(--vh-azul-oscuro) 100%);
  color: white;
  position: relative;
  overflow: hidden;
  padding: 7rem 5%;
}

.impact::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(251, 166, 54, 0.08) 0%, transparent 60%);
  animation: pulse 20s ease-in-out infinite;
}

.impact-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2rem;
  max-width: 1100px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

.impact-item {
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 24px;
  padding: 2.5rem 1.5rem;
  text-align: center;
  transition: var(--vh-transicion);
}

.impact-item:hover {
  background: rgba(255, 255, 255, 0.15);
  transform: translateY(-8px);
  border-color: rgba(251, 166, 54, 0.4);
}

.impact-number {
  font-family: 'League Spartan', sans-serif;
  font-size: 3.5rem;
  font-weight: 800;
  color: var(--vh-dorado);
  display: block;
  margin-bottom: 0.5rem;
  line-height: 1;
}

.impact-label {
  font-size: 1rem;
  opacity: 0.9;
  font-weight: 500;
}

@media (max-width: 768px) {
  .impact-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 480px) {
  .impact-grid {
    grid-template-columns: 1fr;
  }
}
</style>
